import { DefaultEditor } from 'ng2-smart-table';
import { Component, OnInit } from '@angular/core';
import { UNIDADES } from '../constantes-diario';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs';

@Component({
  selector: 'cell-unidad',
  templateUrl: './cell-unidad.component.html',
  styleUrls: ['./cell-unidad.component.scss']
})
export class CellUnidadComponent extends DefaultEditor implements OnInit {

  unidadSeleccionada =""
  unidades$ : Observable<any[]>;
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.unidades$ = of(UNIDADES);
    this.unidadSeleccionada = this.cell.newValue;
  }

}
